import loadable from '@loadable/component';

const ProductTabReviewsExperiment = loadable(() =>
  import(/* webpackChunkName: "ProductTabReviews" */ './product-tab-reviews')
);

export default ProductTabReviewsExperiment;
